import * as React from 'react'

import {cloneCreateOrCallNode} from '@base/react-utils'
import {withOpenedState} from '@base/react-utils/withState'

import PopoversPortal from '@base-uikit/layers/PopoversPortal'
import TetherPosition from '@base-uikit/tether/TetherPosition'
import type {Rectangle} from '@base-uikit/tether/types'

import PopoverBalloon from './PopoverBalloon'
import PopoverController from './PopoverController'

const UncontrolledPopoverController = withOpenedState()(PopoverController)

export type TooltipProps = {
  // If you don't pass opened+onToggle, tooltip opened state will be controlled automatically
  opened?: boolean
  onToggle?: (opened: boolean) => void
  content:
    | React.ReactNode
    | undefined
    | null
    | (() => React.ReactNode | undefined | null)
  color?: 'tooltip' | 'danger'
  padded?: boolean
  toggleOnHover?: boolean | number
  toggleOnFocus?: boolean
  placement?: string
  containerPadding?: number | Partial<Rectangle>
  portal?: null | React.ComponentType<any> | (() => React.ReactElement<any>)
  children?: React.ReactNode | null
  className?: string
  style?: any
  closeOnOutsideClick?: boolean
}

export default function Tooltip(props: TooltipProps) {
  const {
    color = 'tooltip',
    padded = true,
    content,

    toggleOnHover = 300,
    toggleOnFocus = true,
    placement = 'top,bottom',
    containerPadding = 32,
    portal = PopoversPortal,
    children,

    ...otherProps
  } = props

  return (
    <UncontrolledPopoverController
      {...otherProps}
      // @ts-ignore Ignored during migration
      renderPopover={(popoverProps) => (
        <PopoverBalloon
          {...popoverProps}
          size="s"
          padded={padded}
          color={color}
        >
          {cloneCreateOrCallNode(content)}
        </PopoverBalloon>
      )}
      renderPosition={(positionProps) => (
        <TetherPosition
          {...positionProps}
          containerPadding={containerPadding}
          placement={placement}
        />
      )}
      toggleOnHover={toggleOnHover}
      toggleOnFocus={toggleOnFocus}
      portal={portal}
      animation="pop"
      limitTargetToScrollParent
      closeOutOfView="any"
      {...props}
    >
      {children}
    </UncontrolledPopoverController>
  )
}
